import { render, staticRenderFns } from "./nextSaveReport.vue?vue&type=template&id=5022f84e&scoped=true&"
import script from "./nextSaveReport.vue?vue&type=script&lang=js&"
export * from "./nextSaveReport.vue?vue&type=script&lang=js&"
import style0 from "./nextSaveReport.vue?vue&type=style&index=0&id=5022f84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022f84e",
  null
  
)

export default component.exports